import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import { useContext, useEffect, useState } from "react";
import SchwingLogo from "../../../Images/Machines/Batching plant.png";
import dayjs from "dayjs";

import SchwingLogoIndia from "../../../Images/Machines/Batching plant.png";

const tableHeadings = [
  {
    mat: "Materials",
    act: "Actual in Kgs",
  },
];

const ManualConsuptionReport = ({ reportData, from, to }) => {
  const [pdfUrlCh, setPdfUrlCh] = useState(null);

  async function handleGeneratePDF() {
    const pdfDoc = await PDFDocument.create();
    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const schwingIndia = "Schwing India";
    const fontSize = 8.5;
    const pageWidth = 595;
    const pageHeight = 842;
    const title = "Company Name";

    const fromDate = dayjs(from).format("DD-MM-YYYY");
    const toDate = dayjs(to).format("DD-MM-YYYY");

    const data = [];
    for (let y in reportData.data) {
      data.push(reportData.data[y]);
    }

    const x = 125;
    const y = pageHeight - (tableHeadings.length - 2) * fontSize;

    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const pageCount = Math.ceil(data.length / 15);
    let rowY = pageHeight - (tableHeadings.length - 2) * fontSize;
    let rowY2 = y;
    const imageBytes = await fetch(SchwingLogo).then((res) =>
      res.arrayBuffer(),
    );

    const image = await pdfDoc.embedPng(imageBytes);

    const imageBytes1 = await fetch(SchwingLogoIndia).then((res) =>
      res.arrayBuffer(),
    );

    const image1 = await pdfDoc.embedPng(imageBytes1);
    let logo;

    // try {
    //   const imageUrl = sessionStorage.getItem("logoImageUrl"); // Get the image from sessionStorage

    //   if (!imageUrl)
    //     throw new Error("No image URL available in sessionStorage");

    //   const imageBytes = await fetch(imageUrl).then((res) => res.arrayBuffer());

    //   // Embed image based on its format
    //   if (imageUrl.includes("png")) {
    //     logo = await pdfDoc.embedPng(imageBytes);
    //   } else if (imageUrl.includes("jpeg") || imageUrl.includes("jpg")) {
    //     logo = await pdfDoc.embedJpg(imageBytes);
    //   } else {
    //     throw new Error(
    //       "Unsupported image format. Only PNG and JPG are allowed."
    //     );
    //   }
    // } catch (error) {
    //   console.error("Error embedding logo:", error);
    // }

    for (let i = 0; i < pageCount; i++) {
      const startIndex = i * 25;
      const endIndex = Math.min(startIndex + 25, data.length); //sets how many rows should be rendered in one page
      const pageData = data.slice(startIndex, endIndex);

      if (pageData.length > 0) {
        //only if there is data the pdf will be generated
        rowY = 695;
        let page = pdfDoc.addPage([pageWidth, pageHeight]);
        let pageRowY = rowY;

        for (const element of pageData) {
          page.drawText(String(element?.mat_name), {
            x: x + 15,
            y: pageRowY,
            font,
            size: fontSize,
          });
          page.drawText(String(element?.mat_val), {
            x: x + 180,
            y: pageRowY,
            font,
            size: fontSize,
          });
          pageRowY -= 25;
        }

        // if (endIndex === data.length) {
        //   let additionalRowY = Math.max(pageRowY);
        //   let total = 0;
        //   data.forEach((element) => {
        //     total += parseFloat(element.qty);
        //   });

        //   const additionalRowX = x;
        //   page.drawText("Total : ", {
        //     x: additionalRowX + 440,
        //     y: additionalRowY - 3,
        //     font,
        //     size: 10,
        //   });
        //   page.drawText(total.toFixed(4), {
        //     x: additionalRowX + 480,
        //     y: additionalRowY - 3,
        //     font,
        //     size: 10,
        //   });
        // }
        page.drawText("Manual Consumption Report", {
          x: 220,
          y: 775,
          size: 12,
          font,
        });
        page.drawText("Plant Sl No.:", {
          x: 50,
          y: 757,
          size: 12,
          font,
        });

        page.drawText(String(reportData?.p_sl), {
          x: 130,
          y: 757,
          size: 12,
          font,
        });
        page.drawText("Plant Name:", {
          x: 50,
          y: 740,
          size: 12,
          font,
        });
        page.drawText(String(reportData?.p_t), {
          x: 130,
          y: 740,
          size: 12,
          font,
        });

        page.drawText("From Time:", {
          x: 400,
          y: 757,
          size: 12,
          font,
        });
        page.drawText(fromDate.toString(), {
          x: 470,
          y: 757,
          size: 12,
          font,
        });
        page.drawText("To Time:", {
          x: 400,
          y: 740,
          size: 12,
          font,
        });
        page.drawText(toDate.toString(), {
          x: 470,
          y: 740,
          size: 12,
          font,
        });
        tableHeadings &&
          tableHeadings.forEach((header, rowIndex) => {
            rowY2 = y - (rowIndex + 16) * fontSize;

            page.drawText(header.mat.toString(), {
              x: x + 15,
              y: rowY2,
              font: boldFont,
              size: fontSize + 2,
            });
            page.drawText(header.act.toString(), {
              x: x + 180,
              y: rowY2,
              font: boldFont,
              size: fontSize + 2,
            });
          });

        const text = sessionStorage.getItem("comp_name");
        const textWidth = boldFont.widthOfTextAtSize(text, 15);
        const centerX = (pageWidth - textWidth) / 2;

        page.drawText(text, {
          x: centerX,
          y: 800,
          size: 15,
          font: boldFont,
        });

        if (sessionStorage.getItem("leftimage") === "1") {
          page.drawImage(image1, {
            x: 20,
            y: 790,
            width: 100,
            height: 40,
          });
        } else {
          page.drawImage(image, {
            x: 20,
            y: 800,
            width: 100,
            height: 30,
          });
        }

        // if (sessionStorage.getItem("footer") !== "") {
        //   const maxWidth = page.getWidth(); // Get the full page width
        //   const fontSize = 10;
        //   const footerText = sessionStorage.getItem("footer");
        //   const lineHeight = 12;

        //   // Calculate yPos for footer
        //   const yPos = 40;

        //   // Draw a full-width horizontal line above the footer
        //   page.drawLine({
        //     start: { x: 10, y: yPos + 15 }, // Start from left edge
        //     end: { x: maxWidth - 10, y: yPos + 15 }, // End at right edge
        //     thickness: 1,
        //     color: rgb(0, 0, 0), // Black line
        //   });

        //   // Draw the footer text
        //   page.drawText(footerText, {
        //     x: 30,
        //     y: yPos,
        //     size: fontSize,
        //     font: boldFont,
        //     maxWidth: maxWidth - 60, // Adjust to avoid text overflow
        //     lineHeight: lineHeight,
        //   });
        // }

        // if (sessionStorage.getItem("logo") === "1" && logo) {
        //   const imgDims = logo.scale(1); // gets native width & height in points

        //   const targetWidth = 60;
        //   const aspectRatio = imgDims.height / imgDims.width;
        //   const targetHeight = targetWidth * aspectRatio;

        //   page.drawImage(logo, {
        //     x: 490,
        //     y: 780,
        //     width: targetWidth,
        //     height: targetHeight,
        //   });
        // }

        page.drawLine({
          start: { x: 125, y: 728 },
          end: { x: 450, y: 728 },
          thickness: 1,
          color: rgb(0.5, 0.5, 0.5),
          opacity: 0.75,
        });
        page.drawLine({
          start: { x: 125, y: 708 },
          end: { x: 450, y: 708 },
          thickness: 1,
          color: rgb(0.5, 0.5, 0.5),
          opacity: 0.75,
        });
        page.drawLine({
          start: { x: 450, y: 728 },
          end: { x: 450, y: pageRowY + 18 },
          thickness: 1,
          color: rgb(0.5, 0.5, 0.5),
          opacity: 0.75,
        });
        page.drawLine({
          start: { x: 125, y: 728 },
          end: { x: 125, y: pageRowY + 18 },
          thickness: 1,
          color: rgb(0.5, 0.5, 0.5),
          opacity: 0.75,
        });
        page.drawLine({
          start: { x: 125, y: pageRowY + 18 },
          end: { x: 450, y: pageRowY + 18 },
          thickness: 1,
          color: rgb(0.5, 0.5, 0.5),
          opacity: 0.75,
        });
        page.drawLine({
          start: { x: 275, y: 728 }, // Top of data rows
          end: { x: 275, y: pageRowY + 18 }, // Bottom line of table
          thickness: 1,
          color: rgb(0.5, 0.5, 0.5),
          opacity: 0.75,
        });
      }
    }

    // Save the PDF
    const pdfBytes = await pdfDoc.save();

    setPdfUrlCh(
      URL.createObjectURL(new Blob([pdfBytes], { type: "application/pdf" })),
    );
  }

  useEffect(() => {
    if (reportData != null) {
      handleGeneratePDF();
    }
  }, [reportData]);

  return (
    <Grid container spacing={2} alignItems='center'>
      {reportData && (
        <iframe
          src={pdfUrlCh}
          width='100%'
          height='600px'
          title='Batch Report PDF'
        />
      )}
    </Grid>
  );
};

export default ManualConsuptionReport;
